export class AgreementVersionsResult {
    versions: AgreementVersionItem[] = [];
}

export interface AgreementVersionItem {
    agreementNumber: string,
    recordId: string,
}